import * as S from "../../Style/Page/Car.style.js";
import { Link } from "react-router-dom";
import { ReactComponent as Home } from "../../assets/icon/home.svg";
import Arrow from "../../assets/icon/lnb_arrow.png";
import PageTitle from "../../Component/PageTitleCar.js";
import HatPageTopLine from "../../Component/CarPageTopLine.js";

const BusBusinessHistory = () => {
  return (
    <S.Page className={localStorage.getItem("language")}>
      <HatPageTopLine name={"상용버스사업"} />
      <section className="section" id="hat-introduce-section">
        <S.PageNavidation>
          <Link to="/" className="logo">
            <Home />
          </Link>
          <S.Nav height={"364px"}>
            <S.NavItem>
              <Link to="/BusBusiness/OverseasBus">
                <div className="kor">버스사업</div>
                <div className="eng">Bus Business</div>
              </Link>
            </S.NavItem>

            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">지게차사업</div>
                  <div className="eng">Fork Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/introduce">
                  <div className="kor">자동차사업</div>
                  <div className="eng">Car Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">버스사업</div>
                  <div className="eng">Bus Business</div>
                </Link>
              </S.NavItem>

              <S.NavItem className="list-inner-item">
                <Link to="/GeneralBusiness/introduce">
                  <div className="kor">일반사업</div>
                  <div className="eng">General Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">
                  <div className="kor">사회사업</div>
                  <div className="eng">Social Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/WBH/WBH">WBH</Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"156px"}>
            <S.NavItem>
              <Link to="/BusBusiness/BusBusinessHistory">
                <div className="kor">버스사업이력</div>
                <div className="eng">Major business history</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">해외 상용버스사업</div>
                  <div className="eng">Overseas commercial bus business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/Factory">
                  <div className="kor">생산공장</div>
                  <div className="eng">production plant</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/BusBusinessHistory">
                  <div className="kor">버스사업이력</div>
                  <div className="eng">Major business history</div>
                </Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
        </S.PageNavidation>
        <div className="wrap">
          <div className="inner">
            <PageTitle titleko={"버스사업 / 주요 사업이력"} titleeng={"Zyle Motors Overseas Business / Major business history"}/>
            <S.HistoryTable class="history-table">
              <div class="history-table-head">
                <div class="history-table-ceil-small" style={{ borderRightColor: "#fff" }}>
                <div className="kor">구분</div>
                <div className="eng">Year</div>
                </div>
                <div class="history-table-ceil-big">
                <div className="kor">주요 사업내용</div>
                <div className="eng">Major business history</div>
                </div>
              </div>

              <div class="history-table-line">
                <div class="history-table-ceil-small">1955</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                  <div className="kor">신진공업사 설립</div>
                  <div className="eng">Establishment of Shinjin Industry</div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">1965</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                  <div className="kor">신진자동차공업(주) 출범</div>
                  <div className="eng">Launch of Shinjin Motors Industry Co., Ltd.</div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">1972</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                  <div className="kor">GM코리아(GMK) 설립</div>
                  <div className="eng">Establishment of GM-Korea(GMK)</div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">1976</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                  <div className="kor">1976년 새한자동차(주) 출범</div>
                  <div className="eng">Launch of Saehan Motors Co., Ltd.</div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">1982</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                  <div className="kor">대우자동차(주) 출범</div>
                  <div className="eng">Launch of Daewoo Motors Co., Ltd</div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">2002</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">대우버스(주)설립 (GM대우에서 회사 분리)</div>
                    <div className="eng">Establishment of Daewoo Bus Corp.(Separted from GM-Daewoo)</div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">2003</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                  <div className="kor">영안모자계열, 대우버스(주) 인수</div>
                  <div className="eng">Youngan Hat group acquired Daewoo Bus Corp.</div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">2006</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">울산공장 생산 개시(부산공장 2곳 / 울산공장 1곳 운영)</div>
                    <div className="eng">Start Production in Ulsan factory(Operate 2 Busan factory)</div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">2010</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">울산공장으로 통합 운영</div>
                    <div className="eng">Integrated operation with Ulsan factory</div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">2021</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">자일대우버스(주)로 상호 변경</div>
                    <div className="eng">Change name to Zyle Daewoo Bus Corp.</div>
                  </div>
                </div>
              </div>
              <div class="history-table-line last-line">
                <div class="history-table-ceil-small">2021</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">해외법인 지분 자일자동차(주)에서 인수</div>
                    <div className="eng">Zyle Motors acquired share of overseas corporation</div>
                  </div>
                </div>
              </div>
            </S.HistoryTable>
          </div>
        </div>
      </section>
    </S.Page>
  );
};

export default BusBusinessHistory;
